import React, { useEffect, useState, useRef } from 'react';
import { useTheme, createUseStyles } from 'react-jss';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import Container from '@components/Container';

import TrancSourceModal from '@modules/Modal/Trac/TrancSourceModal';
import TrancSourceBase from '@components/TrancSourceBase';
import TrancCertModal from '@modules/Modal/Trac/TrancCertModal';

import { getCustomData } from '@utils/Analysis';
import { lockScroll } from '@utils/ui';

const useStyles = createUseStyles(({
  rem,
}) => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: [rem(10), rem(20)],
    color: 'rgba(0, 0, 0, 1)',
    backgroundColor: 'rgba(255, 255, 255, 1)',
  },
  title: {
    fontSize: rem(16),
    lineHeight: rem(24),
  },
  icons: {
    width: '100%',
    margin: '0 auto',
    borderRadius: '5px',
    marginTop: 14,
    border: '1px solid #E7F5FE',
    '& > div': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto',
      padding: [rem(16), 0],
      '& > img': {
        marginTop: 10,
      },
    },
  },
  subTitle: {
    fontSize: rem(14),
    color: '#595959',
    margin: [rem(25), 0],
  },
  more: {
    width: '100%',
    textAlign: 'center',
    margin: '10px auto',
    color: '#57BCF9',
    cursor: 'pointer',
  },
}), {
  name: 'TrancSource'
})

// 溯源信息
const TrancSource = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { t, data, language } = props;
  const [isHidden, setIsHidden] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [openTrancSource, setOpenTrancSource] = useState(false);

  const [openTrancCert, setOpenTrancCert] = useState(false);

  const [maxHeight, setMaxHeight] = useState(675);
  const areaRef = useRef(null);

  const [belong, setBelong] = useState({}); // 弹窗索引使用

  const handleOpenModal = async (belong, index) => {
    await setBelong({
      belong,
      index,
    });
    setOpenTrancSource(true);
    lockScroll();
  }

  const handleOpenTrancCertModal = async (belong, index) => {
    await setBelong({
      belong,
      index,
    });
    setOpenTrancCert(true);
    lockScroll();
  }

  const dcp1Info = R.pathOr([], ['jsonData', 'dcp1'])(data).filter(item => {
    return item.base && item.base.name;
  });
  console.log('dcp1Info', dcp1Info)
  const dcp1Len = dcp1Info.length;
  const createMaterialArea = () => {
    if (dcp1Len <= 0) return null;
    return dcp1Info.map((item, index) => (
      <TrancSourceBase
        t={t}
        key={index}
        type={t('procurement')}
        belong='dcp1'
        idx={index}
        icon='./static/images/products/dcp1.png'
        data={item}
        handleOpenModal={handleOpenModal}
        handleOpenTrancCertModal={handleOpenTrancCertModal}
      />
    ));
  };

  const dcp2Info = R.pathOr([], ['jsonData', 'dcp2'])(data).filter(item => {
    return item.base && item.base.name;
  });
  const dcp2Len = dcp2Info.length;
  const createSpinArea = () => {
    if (dcp2Len <= 0) return null;
    return dcp2Info.map((item, index) => (
      <TrancSourceBase
        t={t}
        key={index}
        type={t('yarn')}
        belong='dcp2'
        idx={index}
        icon='./static/images/products/dcp2.png'
        data={item}
        handleOpenModal={handleOpenModal}
        handleOpenTrancCertModal={handleOpenTrancCertModal}
      />
    ));
  };

  const dcp3Info = R.pathOr([], ['jsonData', 'dcp3'])(data).filter(item => {
    return item.base && item.base.name;
  });
  const dcp3Len = dcp3Info.length;
  const createWeavingArea = () => {
    if (dcp3Len <= 0) return null;
    return dcp3Info.map((item, index) => (
      <TrancSourceBase
        t={t}
        key={index}
        type={t('weav')}
        belong='dcp3'
        idx={index}
        icon='./static/images/products/dcp3.png'
        data={item}
        handleOpenModal={handleOpenModal}
        handleOpenTrancCertModal={handleOpenTrancCertModal}
      />
    ));
  };

  const dcp4Info = R.pathOr([], ['jsonData', 'dcp4'])(data).filter(item => {
    return item.base && item.base.name;
  });
  const dcp4Len = dcp4Info.length;
  const createTailoringArea = () => {
    if (dcp4Len <= 0) return null;
    return dcp4Info.map((item, index) => (
      <TrancSourceBase
        t={t}
        key={index}
        type={t('garment')}
        belong='dcp4'
        idx={index}
        icon='./static/images/products/dcp4.png'
        data={item}
        handleOpenModal={handleOpenModal}
        handleOpenTrancCertModal={handleOpenTrancCertModal}
      />
    ));
  };

  const trackinfo = R.pathOr([], ['jsonData', 'trackinfo'])(data).filter(item => {
    return item.base && item.base.name;
  });
  const trackinfoLen = (trackinfo && trackinfo.length) || 0;
  const createTrackinfoArea = () => {
    if (trackinfoLen <= 0) return null;
    return trackinfo.map((item, index) => (
      <TrancSourceBase
        t={t}
        key={index}
        type={t('shipment')}
        belong='trackinfo'
        idx={index}
        icon='./static/images/products/trackinfo.png'
        data={item}
        handleOpenModal={handleOpenModal}
      />
    ));
  };

  const totalLen = dcp1Len + dcp2Len + dcp3Len + dcp4Len + trackinfoLen;
  const custom = getCustomData(data);
  const logoImage = R.pathOr('', ['logoimage', 'filelocation'])(custom);

  useEffect(() => {
    if (totalLen <= 5) {
      setIsHidden(true);
    }
  }, [totalLen]);

  const handleShowArea = () => {
    if (!isShow) {
      setMaxHeight(totalLen * 135);
    } else {
      setMaxHeight(135 * 5);
    }
    setIsShow(!isShow);
  }



  return (
    <>
      {totalLen && <Container className={classNames(classes.root)} id='trac'>
        <h2 className={classes.title} value='trac'>{t('traceability')}</h2>
        <Container
          flex
          justify='space-between'
          className={classes.icons}
        >
          <div>
            <span>Powered by</span>
            <img src="./static/images/logo_vechain.png" alt="icon" width={100} />
          </div>
          <hr/>
          <div>
            <span>Partner with</span>
            <img src={logoImage} alt="logo" width={90} />
          </div>
        </Container>

        {/*追溯记录 title*/}
        <span className={classes.subTitle}>{`${totalLen}${t('records')}`}</span>

        {/*追溯记录 list*/}
        <Container
          ref={areaRef}
          style={{
            overflow: 'hidden',
            maxHeight: maxHeight,
          }}
        >
          {
            (dcp1Info && dcp1Info.length > 0) && createMaterialArea()
          }
          {
            (dcp2Info && dcp2Info.length > 0) && createSpinArea()
          }
          {
            (dcp3Info && dcp3Info.length > 0) && createWeavingArea()
          }
          {
            (dcp4Info && dcp4Info.length > 0) && createTailoringArea()
          }
          {
            (trackinfo && trackinfo.length > 0) && createTrackinfoArea()
          }
        </Container>
        {!isHidden && (
          <span
            className={classes.more}
            onClick={() => handleShowArea()}
          >
            {isShow ? t('less') : t('more')}
          </span>
        )}
      </Container>}
      {
        openTrancSource && (
          <TrancSourceModal
            t={t}
            data={belong}
            language={language}
            trackinfo={trackinfo}
            setOpenTrancSource={setOpenTrancSource}
          />
        )
      }

      {
        openTrancCert && (
          <TrancCertModal
            t={t}
            data={belong}
            language={language}
            setOpenTrancCert={setOpenTrancCert}
          />
        )
      }
    </>
  )
};

TrancSource.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
}

export default TrancSource;
